/* Let's talk Decaf – 19grams Decaf Landingpage, Espresso + Filter (Präfix dlp). Neue Module in dlp-plus.js */
(function () {
  'use strict';

  var RM = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var NB = ' ';

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function uniq(arr) { var o = []; arr.forEach(function (x) { if (x != null && o.indexOf(x) < 0) o.push(x); }); return o; }
  function clamp(n, a, b) { return Math.max(a, Math.min(b, n)); }

  /* ---------- Formatierung ---------- */
  function makeMoney(cur) {
    var nf = null;
    try { nf = new Intl.NumberFormat('de-DE', { style: 'currency', currency: cur || 'EUR' }); } catch (e) { nf = null; }
    return function (cents) {
      cents = Math.round(cents);
      var T = window.theme;
      if ((!cur || cur === 'EUR') && T && T.Currency && typeof T.Currency.formatMoney === 'function' && T.shopSettings && T.shopSettings.moneyFormat) {
        try { return T.Currency.formatMoney(cents, T.shopSettings.moneyFormat); } catch (e) { /* weiter unten */ }
      }
      return nf ? nf.format(cents / 100) : (cents / 100).toFixed(2).replace('.', ',') + NB + '€';
    };
  }
  function grams(s) {
    var m = String(s || '').replace(',', '.').match(/(\d+(?:\.\d+)?)\s*(kg|g)\b/i);
    if (!m) return 0;
    return parseFloat(m[1]) * (m[2].toLowerCase() === 'kg' ? 1000 : 1);
  }
  function sizeLabel(s) {
    var g = grams(s);
    if (!g) return String(s || '');
    return g >= 1000 ? String(g / 1000).replace('.', ',') + NB + 'kg' : g + NB + 'g';
  }
  var GRINDS = { 'ganze bohne': 'Ganze Bohne', 'espresso maschine': 'Gemahlen für Siebträger', 'bialetti': 'Gemahlen für Mokkakanne',
    'v60': 'Gemahlen für V60', 'chemex': 'Gemahlen für Chemex', 'frenchpress': 'Gemahlen für French Press', 'moccamaster': 'Gemahlen für Filtermaschine' };
  var GRINDS_SHORT = { 'ganze bohne': 'Ganze Bohne', 'espresso maschine': 'Für Siebträger', 'bialetti': 'Für Mokkakanne',
    'v60': 'V60', 'chemex': 'Chemex', 'frenchpress': 'French Press', 'moccamaster': 'Moccamaster' };
  function grindLabel(g, short) {
    if (!g) return '';
    var t = String(g).trim(), k = t.toLowerCase();
    return (short ? GRINDS_SHORT[k] : GRINDS[k]) || (t.charAt(0).toUpperCase() + t.slice(1));
  }
  /* Segment-Buttons (Menge, Mahlung, Intervall …) */
  function segRender(el, items, cur, onPick) {
    if (!el) return;
    el.innerHTML = '';
    items.forEach(function (it) {
      var b = document.createElement('button');
      b.type = 'button';
      b.textContent = it.label;
      b.setAttribute('aria-pressed', String(it.value) === String(cur) ? 'true' : 'false');
      if (it.disabled) { b.disabled = true; if (it.title) b.title = it.title; }
      b.addEventListener('click', function () { onPick(it.value); });
      el.appendChild(b);
    });
  }
  /* „Reife Feige“ -> „reife Feige“, damit es im Satz passt */
  function inSentence(note) {
    var w = String(note || '').trim().split(/\s+/);
    if (w.length > 1 && /(e|er|es|en|em)$/i.test(w[0])) w[0] = w[0].toLowerCase();
    return w.join(' ');
  }

  /* ---------- Warenkorb ---------- */
  function rootUrl() {
    var T = window.theme || {};
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || (T.routes && T.routes.root_url) || '/';
    return r.slice(-1) === '/' ? r : r + '/';
  }
  function cartUrl() {
    var T = window.theme || {};
    return (T.routes && T.routes.cart_url) || rootUrl() + 'cart';
  }
  function cartAdd(items) {
    var T = window.theme || {};
    var mini = document.querySelector('mini-cart');
    var drawer = !!(mini && typeof mini.renderContents === 'function' && typeof mini.getSectionsToRender === 'function' &&
      !(T.shopSettings && T.shopSettings.cartDrawer === false) && !document.body.classList.contains('template-cart'));
    var body = { items: items };
    if (drawer) {
      body.sections = mini.getSectionsToRender().map(function (s) { return s.section || s.id; });
      body.sections_url = window.location.pathname;
    }
    return fetch(rootUrl() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (d) { return { ok: r.ok, d: d || {} }; });
    }).then(function (res) {
      var d = res.d;
      if (!res.ok || d.status) throw new Error(d.description || d.message || 'Das hat nicht geklappt. Versuch es bitte nochmal.');
      try {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'decaf-lp', productVariantId: items[0].id });
        }
      } catch (e) { /* egal */ }
      if (drawer) {
        try { mini.renderContents(d); return 'drawer'; } catch (e) { return 'added'; }
      }
      window.location.href = cartUrl();
      return 'redirect';
    });
  }
  function busy(btn, on) {
    if (!btn) return;
    btn.classList.toggle('is-loading', !!on);
    if (on) btn.setAttribute('aria-busy', 'true'); else btn.removeAttribute('aria-busy');
  }
  function done(st, r) {
    if (!st || r === 'redirect') return;
    st.classList.remove('is-error');
    st.textContent = 'Liegt im Warenkorb.';
    if (r === 'added') {
      var a = document.createElement('a');
      a.href = cartUrl();
      a.textContent = ' Zum Warenkorb →';
      st.appendChild(a);
    }
    clearTimeout(st._t);
    st._t = setTimeout(function () { st.textContent = ''; }, 7000);
  }
  function fail(st, err) {
    if (!st) return;
    clearTimeout(st._t);
    st.classList.add('is-error');
    st.textContent = (err && err.message) || 'Das hat nicht geklappt. Versuch es bitte nochmal.';
  }

  /* ---------- Reveal ---------- */
  function initReveal(root) {
    var els = $$('[data-dlp-reveal]', root);
    if (RM || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- Anker ---------- */
  function initAnchors(root) {
    $$('a[href^="#dlp-"]', root).forEach(function (a) {
      a.addEventListener('click', function (e) {
        var t = document.getElementById(a.getAttribute('href').slice(1));
        if (!t) return;
        e.preventDefault();
        t.scrollIntoView({ behavior: RM ? 'auto' : 'smooth', block: 'start' });
      });
    });
  }

  /* ---------- Hero: schlafende Bohne ---------- */
  function initHero(root, data) {
    var hero = $('[data-dlp-hero]', root);
    if (!hero) return;
    var scene = $('[data-dlp-scene]', hero);
    var bubble = $('[data-dlp-bubble]', hero);
    var lights = $('[data-dlp-lights]', hero);
    var lightsLabel = lights && $('[data-dlp-lights-label]', lights);
    var notes = (data.notes || []).filter(Boolean);
    var smell = inSentence(notes[0] || 'Kaffee');
    var timers = [], running = false, bubbleTimer = null, pokeIdx = 0;
    var pokes = [
      'Noch fünf Minuten …',
      'Ich hab mein Koffein abgegeben. Lass mich schlafen.',
      'Ich zähl noch Bohnen. 1 … 2 … Zzz',
      'Bin wach. Fast.'
    ];

    function later(fn, ms) { timers.push(setTimeout(fn, ms)); }
    function showBubble(text, ms) {
      if (!bubble) return;
      bubble.textContent = text;
      bubble.classList.add('is-on');
      clearTimeout(bubbleTimer);
      if (ms) bubbleTimer = setTimeout(function () { bubble.classList.remove('is-on'); }, ms);
    }
    function hideBubble() { if (bubble) bubble.classList.remove('is-on'); }
    function jolt() {
      if (RM || !scene) return;
      scene.classList.remove('is-jolt');
      void scene.offsetWidth;
      scene.classList.add('is-jolt');
    }
    function brew() {
      if (running || !scene) return;
      running = true;
      timers.forEach(clearTimeout); timers = [];
      clearTimeout(bubbleTimer); hideBubble();
      scene.classList.remove('is-awake');
      scene.classList.add('is-brewing');
      var t = RM ? 250 : 2100;
      later(function () { scene.classList.add('is-awake'); jolt(); showBubble('Moment … ist das etwa ' + smell + '?'); }, t);
      later(function () { showBubble('Ah, Decaf! Bring mir ’ne Tasse ans Bett.'); }, t + 2600);
      later(function () { hideBubble(); scene.classList.remove('is-awake'); }, t + 5200);
      later(function () { scene.classList.remove('is-brewing'); running = false; }, t + 5900);
    }

    $$('[data-dlp-brew]', hero).forEach(function (b) { b.addEventListener('click', brew); });
    var bean = $('[data-dlp-bean]', hero);
    if (bean) bean.addEventListener('click', function () {
      if (running) return;
      jolt();
      showBubble(pokes[pokeIdx++ % pokes.length], 2400);
    });
    if (lights) lights.addEventListener('click', function () {
      var night = !hero.classList.contains('is-night');
      hero.classList.toggle('is-night', night);
      lights.setAttribute('aria-pressed', night ? 'true' : 'false');
      if (lightsLabel) lightsLabel.textContent = night ? 'Lights on' : 'Lights off';
      if (!running) showBubble(night ? 'Danke. Endlich.' : 'Hey! Licht aus, bitte.', 2000);
    });

    if (!RM && scene && 'IntersectionObserver' in window) {
      var auto = new IntersectionObserver(function (en) {
        if (en[0].isIntersecting) { auto.disconnect(); setTimeout(brew, 2400); }
      }, { threshold: 0.5 });
      auto.observe(scene);
    }
  }

  /* ---------- Kaufbox ---------- */
  function initBuy(root, data, money) {
    $$('[data-dlp-buy]', root).forEach(function (form) {
      var set = (data.sets && data.sets[form.getAttribute('data-dlp-set')]) || data;
      try { initBuyForm(form, set, money); } catch (e) { if (window.console) console.error('[decaf-lp]', e); }
    });
  }
  function initBuyForm(form, data, money) {
    var price = $('[data-dlp-price]', form), unit = $('[data-dlp-unit]', form);
    var qty = $('[data-dlp-qty-input]', form), add = $('[data-dlp-add]', form), st = $('[data-dlp-status]', form);
    var byId = {};
    (data.main || []).forEach(function (v) { byId[v.id] = v; });

    $$('[data-dlp-vlabel]', form).forEach(function (s) {
      var p = s.getAttribute('data-dlp-vlabel').split('|');
      s.textContent = sizeLabel(p[0]) + (p[1] ? ' · ' + grindLabel(p[1]) : '');
    });
    function unitText(v) {
      if (v.unitPrice) return '(' + money(v.unitPrice) + '/' + (v.unitRef && +v.unitRef !== 1 ? v.unitRef + ' ' : '') + (v.unitUnit || 'kg') + ')';
      var g = grams(v.size);
      return g ? '(' + money(v.price / g * 1000) + '/kg)' : '';
    }
    function current() {
      var r = form.querySelector('input[type="radio"]:checked');
      return r ? byId[+r.value] : null;
    }
    function qtyVal() { return clamp(parseInt(qty.value, 10) || 1, 1, 20); }
    function update() {
      var v = current();
      if (!v) return;
      if (price) price.textContent = money(v.price);
      if (unit) unit.textContent = unitText(v);
      if (add) {
        add.disabled = !v.available;
        add.textContent = v.available ? 'In den Warenkorb' : 'Gerade ausverkauft';
      }
    }
    form.addEventListener('change', function (e) {
      if (e.target && e.target.type === 'radio') { update(); if (st) st.textContent = ''; }
    });

    /* Zweistufige Auswahl: erst Menge, dann Mahlung (Radios bleiben als Fallback ohne JS) */
    var fs = $('.dlp-opts', form), main = data.main || [];
    if (fs && main.length > 1) {
      var sizes = uniq(main.map(function (v) { return v.size; }));
      var grinds = uniq(main.map(function (v) { return v.grind; }));
      var init = current() || main[0];
      var S = { size: init.size, grind: init.grind };
      var box = document.createElement('div');
      box.className = 'dlp-buy__opts';
      box.innerHTML = '<p class="dlp-buy__label">Menge</p><div class="dlp-seg" role="group" aria-label="Menge" data-dlp-buy-sizes></div>' +
        (grinds.length > 1 ? '<p class="dlp-buy__label">Mahlung</p><div class="dlp-seg" role="group" aria-label="Mahlung" data-dlp-buy-grinds></div>' : '');
      fs.parentNode.insertBefore(box, fs);
      fs.hidden = true;
      var elS = $('[data-dlp-buy-sizes]', box), elG = $('[data-dlp-buy-grinds]', box);
      var renderSeg = function () {
        var okSizes = sizes.filter(function (z) { return main.some(function (v) { return v.size === z && v.available; }); });
        segRender(elS, sizes.map(function (z) {
          return { value: z, label: sizeLabel(z), disabled: okSizes.indexOf(z) < 0, title: 'Gerade ausverkauft' };
        }), S.size, function (val) { S.size = val; pick(); });
        var okG = main.filter(function (v) { return v.size === S.size && v.available; }).map(function (v) { return v.grind; });
        segRender(elG, grinds.map(function (g) {
          return { value: g, label: grindLabel(g, true), disabled: okG.indexOf(g) < 0, title: 'Für diese Menge nicht verfügbar' };
        }), S.grind, function (val) { S.grind = val; pick(); });
      };
      var pick = function () {
        var okG = main.filter(function (v) { return v.size === S.size && v.available; }).map(function (v) { return v.grind; });
        if (okG.indexOf(S.grind) < 0 && okG.length) S.grind = okG[0];
        var v = main.filter(function (x) { return x.size === S.size && x.grind === S.grind; })[0];
        if (v) {
          var r = form.querySelector('input[type="radio"][value="' + v.id + '"]');
          if (r) { r.disabled = false; r.checked = true; }
        }
        renderSeg();
        update();
        if (st) st.textContent = '';
      };
      renderSeg();
    }
    $$('[data-dlp-qty]', form).forEach(function (b) {
      b.addEventListener('click', function () { qty.value = clamp(qtyVal() + (+b.getAttribute('data-dlp-qty')), 1, 20); });
    });
    if (qty) qty.addEventListener('change', function () { qty.value = qtyVal(); });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = current();
      if (!v || !v.available) return;
      busy(add, true);
      cartAdd([{ id: v.id, quantity: qtyVal() }])
        .then(function (r) { done(st, r); })
        .catch(function (err) { fail(st, err); })
        .then(function () { busy(add, false); });
    });
    update();
  }

  /* ---------- Abo-Konfigurator ---------- */
  function initAbo(root, data, money) {
    $$('[data-dlp-abo]', root).forEach(function (box) {
      var set = (data.sets && data.sets[box.getAttribute('data-dlp-set')]) || data;
      try { initAboBox(box, set, money, data); } catch (e) { if (window.console) console.error('[decaf-lp]', e); }
    });
  }
  function initAboBox(box, data, money, all) {
    var modes = $$('[data-dlp-mode]', box);
    var elSizes = $('[data-dlp-abo-sizes]', box), elGrinds = $('[data-dlp-abo-grinds]', box);
    var elInt = $('[data-dlp-abo-intervals]', box), elTerms = $('[data-dlp-abo-terms]', box);
    var outPrice = $('[data-dlp-abo-price]', box), outPer = $('[data-dlp-abo-per]', box);
    var outWas = $('[data-dlp-abo-was]', box), outSave = $('[data-dlp-abo-save]', box);
    var outFacts = $('[data-dlp-abo-facts]', box), cta = $('[data-dlp-abo-cta]', box), st = $('[data-dlp-abo-status]', box);
    var maxG = +data.maxPrepaidGrams || 0;
    function capped(l) { return maxG ? (l || []).filter(function (v) { var g = grams(v.size); return !g || g <= maxG; }) : (l || []); }
    var lists = { unlimited: data.unlimited || [], 6: capped(data.pre6), 12: capped(data.pre12) };
    var S = { mode: 'unlimited', size: null, grind: null, weeks: 4, term: 6 };
    var item = null;

    if (!lists.unlimited.length && (lists[6].length || lists[12].length)) S.mode = 'limited';
    if (!lists[6].length && lists[12].length) S.term = 12;

    function list() { return S.mode === 'unlimited' ? lists.unlimited : lists[S.term]; }
    function mainFor(size, grind) {
      var m = data.main || [];
      return m.filter(function (v) { return v.size === size && v.grind === grind; })[0] || null;
    }
    function variant() {
      return list().filter(function (v) { return v.size === S.size && v.grind === S.grind; })[0] || null;
    }
    function aboPlans(v) {
      if (!v) return [];
      var p = v.plans || [];
      var g = p.filter(function (x) { return String(x.group) === String(data.aboGroup); });
      return g.length ? g : p;
    }
    function every(plan) {
      var name = String((plan && plan.name) || '');
      var m = name.match(/(\d+)/);
      return { n: m ? +m[1] : 0, month: /month|monat/i.test(name) };
    }
    function intervalLabel(w) {
      if (w.month) return w.n === 1 ? 'Jeden Monat' : 'Alle ' + w.n + ' Monate';
      return w.n === 1 ? 'Jede Woche' : 'Alle ' + w.n + ' Wochen';
    }
    function deliveryText(w) {
      if (w.month) return w.n === 1 ? 'Lieferung jeden Monat' : 'Lieferung alle ' + w.n + ' Monate';
      return w.n === 1 ? 'Lieferung jede Woche' : 'Lieferung alle ' + w.n + ' Wochen';
    }
    var seg = segRender;
    function facts(arr) {
      if (!outFacts) return;
      outFacts.innerHTML = arr.filter(Boolean).map(function (t) { return '<li>' + esc(t) + '</li>'; }).join('');
    }
    function unavailable() {
      outPrice.textContent = '–';
      outPer.textContent = '';
      outWas.innerHTML = '';
      outSave.textContent = '';
      facts(['Diese Kombination gibt es gerade nicht. Probier eine andere Menge oder Mahlung.']);
      cta.disabled = true;
      cta.textContent = 'Gerade nicht verfügbar';
      item = null;
    }
    function compare(single, total, prefix) {
      if (single && single > total) {
        outWas.innerHTML = esc(prefix) + '<s>' + esc(money(single)) + '</s>';
        /* abrunden, damit die Ersparnis nie größer angezeigt wird, als sie ist */
        var pct = Math.floor((single - total) * 100 / single + 1e-9);
        outSave.textContent = pct >= 1 ? 'Du sparst ' + pct + NB + '%' : '';
      } else {
        outWas.innerHTML = '';
        outSave.textContent = '';
      }
    }

    function showUnlimited(v, plan, w) {
      if (!v || !plan) return unavailable();
      var g = grams(v.size), m = mainFor(v.size, v.grind);
      outPrice.textContent = money(plan.price);
      outPer.textContent = ' pro Lieferung' + (g ? ' (' + money(plan.price / g * 1000) + '/kg)' : '');
      compare(m && m.price, plan.price, 'Einzeln: ');
      facts([
        deliveryText(w),
        'Mindestlaufzeit 3 Lieferungen, danach jederzeit kündbar',
        (all && all.aboFreeShipping) ? 'Inkl. MwSt., versandkostenfrei in Deutschland' : 'Inkl. MwSt., zzgl. Versand',
        'Frisch geröstet in Berlin'
      ]);
      cta.disabled = !v.available;
      cta.textContent = v.available ? 'Abo starten' : 'Gerade ausverkauft';
      item = { id: v.id, quantity: 1, selling_plan: plan.id };
    }
    function showLimited(v, plan, term) {
      if (!v || !plan) return unavailable();
      var name = String(plan.name || '');
      var dm = name.match(/(?:delivery|lieferung)[^\d]*(\d+)\s*(?:month|monat)/i);
      var cm = name.match(/(?:charge|zahlung|abrechnung)[^\d]*(\d+)\s*(?:month|monat)/i);
      var every = dm ? +dm[1] : 1;
      var months = cm ? +cm[1] : term;
      var n = Math.max(1, Math.round(months / every));
      var total = plan.price, g = grams(v.size), m = mainFor(v.size, v.grind);
      outPrice.textContent = money(total);
      outPer.textContent = ' einmalig für ' + n + ' Lieferungen' + (g ? ' (' + money(total / (g * n) * 1000) + '/kg)' : '');
      compare(m && m.price * n, total, n + ' × einzeln: ');
      if (outWas.innerHTML) outWas.innerHTML += ' zzgl. Versand';
      facts([
        'Entspricht ' + money(total / n) + ' pro Lieferung',
        n + ' Lieferungen, ' + (every === 1 ? 'eine pro Monat' : 'alle ' + every + ' Monate'),
        'Inkl. MwSt., versandkostenfrei in Deutschland',
        'Ideal zum Verschenken'
      ]);
      cta.disabled = !v.available;
      cta.textContent = v.available ? 'Abo kaufen' : 'Gerade ausverkauft';
      item = { id: v.id, quantity: 1, selling_plan: plan.id };
    }

    function render() {
      modes.forEach(function (b) {
        var on = b.getAttribute('data-dlp-mode') === S.mode;
        b.setAttribute('aria-checked', on ? 'true' : 'false');
        b.tabIndex = on ? 0 : -1;
      });
      $$('[data-dlp-abo-when]', box).forEach(function (el) { el.hidden = el.getAttribute('data-dlp-abo-when') !== S.mode; });

      var L = list();
      var sizes = uniq(L.map(function (v) { return v.size; }));
      var okSizes = sizes.filter(function (s) { return L.some(function (v) { return v.size === s && v.available; }); });
      if (okSizes.indexOf(S.size) < 0) S.size = okSizes[0] || sizes[0] || null;
      seg(elSizes, sizes.map(function (s) {
        return { value: s, label: sizeLabel(s), disabled: okSizes.indexOf(s) < 0, title: 'Gerade nicht verfügbar' };
      }), S.size, function (val) { S.size = val; render(); });

      var allGrinds = uniq(L.map(function (v) { return v.grind; }));
      var okGrinds = L.filter(function (v) { return v.size === S.size && v.available; }).map(function (v) { return v.grind; });
      if (okGrinds.indexOf(S.grind) < 0) S.grind = okGrinds[0] || allGrinds[0] || null;
      seg(elGrinds, allGrinds.map(function (gr) {
        return { value: gr, label: grindLabel(gr, true), disabled: okGrinds.indexOf(gr) < 0, title: 'Für diese Menge nicht verfügbar' };
      }), S.grind, function (val) { S.grind = val; render(); });

      var v = variant();
      if (S.mode === 'unlimited') {
        var ps = aboPlans(v).map(function (p) { return { p: p, w: every(p) }; })
          .sort(function (a, b) { return (a.w.month - b.w.month) || (a.w.n - b.w.n); });
        if (!ps.some(function (x) { return x.w.n === S.weeks; })) {
          S.weeks = ps.some(function (x) { return x.w.n === 4; }) ? 4 : (ps.length ? ps[ps.length - 1].w.n : 0);
        }
        seg(elInt, ps.map(function (x) { return { value: x.w.n, label: intervalLabel(x.w) }; }), S.weeks, function (val) { S.weeks = +val; render(); });
        var sel = ps.filter(function (x) { return x.w.n === S.weeks; })[0];
        showUnlimited(v, sel && sel.p, sel && sel.w);
      } else {
        seg(elTerms, [6, 12].map(function (n) {
          var ok = lists[n].some(function (x) { return x.size === S.size && x.grind === S.grind && x.available; });
          return { value: n, label: n + ' Monate', disabled: !ok, title: 'Für diese Auswahl nicht verfügbar' };
        }), S.term, function (val) { S.term = +val; render(); });
        showLimited(v, v && (v.plans || [])[0], S.term);
      }
    }

    modes.forEach(function (b, i) {
      b.addEventListener('click', function () { S.mode = b.getAttribute('data-dlp-mode'); if (st) st.textContent = ''; render(); });
      b.addEventListener('keydown', function (e) {
        if (['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].indexOf(e.key) < 0) return;
        e.preventDefault();
        var next = modes[(i + 1) % modes.length];
        S.mode = next.getAttribute('data-dlp-mode');
        render();
        next.focus();
      });
    });
    if (cta) cta.addEventListener('click', function () {
      if (!item) return;
      busy(cta, true);
      cartAdd([item])
        .then(function (r) { done(st, r); })
        .catch(function (err) { fail(st, err); })
        .then(function () { busy(cta, false); });
    });
    render();
  }

  /* ---------- Koffein-Uhr ---------- */
  function initClock(root) {
    var c = $('[data-dlp-clock]', root);
    if (!c) return;
    var inLast = $('[data-dlp-clock-in="last"]', c), inBed = $('[data-dlp-clock-in="bed"]', c);
    var outLast = $('[data-dlp-clock-out="last"]', c), outBed = $('[data-dlp-clock-out="bed"]', c);
    var bar = $('[data-dlp-clock-bar]', c), range = $('[data-dlp-clock-range]', c), text = $('[data-dlp-clock-text]', c);
    if (!inLast || !inBed || !text) return;
    function hhmm(m) {
      m = ((m % 1440) + 1440) % 1440;
      var h = Math.floor(m / 60), mi = m % 60;
      return (h < 10 ? '0' : '') + h + ':' + (mi < 10 ? '0' : '') + mi;
    }
    function update() {
      var last = +inLast.value, bed = +inBed.value;
      if (outLast) outLast.textContent = hhmm(last);
      if (outBed) outBed.textContent = hhmm(bed);
      inLast.setAttribute('aria-valuetext', hhmm(last) + ' Uhr');
      inBed.setAttribute('aria-valuetext', hhmm(bed) + ' Uhr');
      var dt = (bed - last) / 60;
      if (dt <= 0) {
        if (bar) bar.style.width = '100%';
        if (range) { range.style.left = '0'; range.style.width = '0'; }
        text.textContent = 'Kaffee nach dem Zubettgehen? Dann schieb mal einen der Regler.';
        return;
      }
      var avg = Math.pow(0.5, dt / 4) * 100;
      var lo = Math.pow(0.5, dt / 2) * 100;
      var hi = Math.pow(0.5, dt / 8) * 100;
      if (bar) bar.style.width = avg.toFixed(1) + '%';
      if (range) { range.style.left = lo.toFixed(1) + '%'; range.style.width = Math.max(hi - lo, 0).toFixed(1) + '%'; }
      var mg = Math.round(90 * avg / 100);
      var h = dt % 1 === 0 ? String(dt) : String(dt).replace('.', ',');
      text.innerHTML = 'Zwischen Kaffee und Bett liegen ' + h + ' Stunden. Um ' + hhmm(bed) + ' Uhr ist im Schnitt noch etwa <strong>' +
        Math.round(avg) + NB + '%</strong> vom Koffein übrig, je nach Person zwischen ' + Math.round(lo) + NB + '% und ' +
        Math.round(hi) + NB + '%. Bei einer Tasse Filterkaffee (ca. 90 mg) wären das rund ' + mg + ' mg.';
    }
    inLast.addEventListener('input', update);
    inBed.addEventListener('input', update);
    update();
  }

  /* ---------- Mythen, Zeitstrahl ---------- */
  function initFlips(root) {
    $$('.dlp-flip', root).forEach(function (b) {
      b.addEventListener('click', function () {
        b.setAttribute('aria-pressed', b.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
      });
    });
  }
  function initTimeline(root) {
    var track = $('[data-dlp-tl-track]', root);
    if (!track) return;
    $$('[data-dlp-tl]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var li = track.querySelector('li');
        var w = li ? li.getBoundingClientRect().width + 16 : 320;
        track.scrollBy({ left: w * (+b.getAttribute('data-dlp-tl')), behavior: RM ? 'auto' : 'smooth' });
      });
    });
  }

  /* ---------- Brew Guide ---------- */
  var FIX = {
    st: [
      ['Läuft zu schnell', 'Mahl feiner. Bei Decaf reichen oft schon kleine Schritte.'],
      ['Läuft zu langsam', 'Mahl etwas gröber.'],
      ['Schmeckt sauer', 'Mahl feiner oder lass den Shot etwas länger laufen.'],
      ['Schmeckt bitter', 'Mahl etwas gröber oder stopp den Shot früher.'],
      ['Dünn, wässrig', 'Nimm etwas mehr Kaffee ins Sieb.']
    ],
    va: [
      ['Schmeckt sauer', 'Stell den Mahlgrad eine Stufe feiner. Gib der neuen Einstellung ein paar Bezüge Zeit.'],
      ['Schmeckt bitter', 'Stell den Mahlgrad eine Stufe gröber.'],
      ['Dünn, wässrig', 'Dreh die Kaffeestärke hoch oder nimm weniger Wasser pro Tasse.']
    ],
    mk: [
      ['Steigt zu schnell hoch', 'Nimm die Hitze etwas runter.'],
      ['Kommt kaum Kaffee', 'Dreh die Hitze etwas hoch oder füll den Kaffee lockerer ein.'],
      ['Schmeckt bitter', 'Mahl etwas gröber und nimm die Hitze etwas zurück.'],
      ['Dünn, wässrig', 'Füll den Trichter randvoll, streich ihn glatt und drück nicht an.']
    ]
  };
  function initBrew(root) {
    var g = $('[data-dlp-brewguide]', root);
    if (!g) return;
    var tabs = $$('[data-dlp-tab]', g), panels = $$('[data-dlp-panel]', g);
    var chips = $('[data-dlp-fix]', g), out = $('[data-dlp-fix-out]', g);
    var DEFAULT = out ? out.textContent : '';
    function renderChips(key) {
      if (!chips) return;
      chips.innerHTML = '';
      if (out) out.textContent = DEFAULT;
      (FIX[key] || []).forEach(function (f) {
        var b = document.createElement('button');
        b.type = 'button';
        b.textContent = f[0];
        b.setAttribute('aria-pressed', 'false');
        b.addEventListener('click', function () {
          var on = b.getAttribute('aria-pressed') !== 'true';
          $$('button', chips).forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
          if (out) out.textContent = on ? f[1] : DEFAULT;
        });
        chips.appendChild(b);
      });
    }
    function select(key, focus) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-dlp-tab') === key;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (on && focus) t.focus();
      });
      panels.forEach(function (p) { p.hidden = p.getAttribute('data-dlp-panel') !== key; });
      renderChips(key);
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(t.getAttribute('data-dlp-tab')); });
      t.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return;
        e.preventDefault();
        var n = tabs[(i + d + tabs.length) % tabs.length];
        select(n.getAttribute('data-dlp-tab'), true);
      });
    });
    select('st');
  }

  /* ---------- Grownd Quick Add ---------- */
  function initQuick(root) {
    var st = $('[data-dlp-quick-status]', root);
    $$('[data-dlp-quickadd]', root).forEach(function (b) {
      var label = b.textContent;
      b.addEventListener('click', function () {
        var id = +b.getAttribute('data-dlp-quickadd');
        if (!id) return;
        busy(b, true);
        cartAdd([{ id: id, quantity: 1 }])
          .then(function (r) {
            done(st, r);
            b.textContent = 'Liegt drin ✓';
            setTimeout(function () { b.textContent = label; }, 2500);
          })
          .catch(function (err) { fail(st, err); })
          .then(function () { busy(b, false); });
      });
    });
  }

  /* ---------- Chill Mode: generative Musik im Browser ---------- */
  function Chill() {
    var ctx = null, master = null, verb = null, delay = null, padIn = null;
    var playing = false, started = false, timer = null, stopTimer = null;
    var startT = 0, nextChordT = 0, chordIdx = 0, nextPluckT = 0, melIdx = 2, vol = 0.6;
    var BAR = 8;
    var CH = [
      { bass: 41, notes: [53, 57, 60, 64], mel: [69, 72, 76, 79, 81, 84] },
      { bass: 40, notes: [52, 55, 59, 62], mel: [67, 71, 74, 76, 79, 83] },
      { bass: 38, notes: [50, 53, 57, 60], mel: [69, 72, 74, 77, 81, 84] },
      { bass: 36, notes: [48, 52, 55, 59], mel: [67, 72, 76, 79, 83, 84] }
    ];
    function mtof(m) { return 440 * Math.pow(2, (m - 69) / 12); }
    function target() { return 0.55 * Math.pow(vol, 1.6); }
    function impulse(sec, decay) {
      var rate = ctx.sampleRate, len = Math.floor(rate * sec), buf = ctx.createBuffer(2, len, rate);
      for (var c = 0; c < 2; c++) {
        var d = buf.getChannelData(c);
        for (var i = 0; i < len; i++) d[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / len, decay);
      }
      return buf;
    }
    function brown(sec) {
      var len = Math.floor(ctx.sampleRate * sec), b = ctx.createBuffer(1, len, ctx.sampleRate), d = b.getChannelData(0), last = 0, i;
      for (i = 0; i < len; i++) { last = (last + 0.02 * (Math.random() * 2 - 1)) / 1.02; d[i] = last * 3.5; }
      var diff = d[len - 1] - d[0];
      for (i = 0; i < len; i++) d[i] -= diff * i / (len - 1);
      return b;
    }
    function crackle(sec) {
      var len = Math.floor(ctx.sampleRate * sec), b = ctx.createBuffer(1, len, ctx.sampleRate), d = b.getChannelData(0);
      for (var i = 0; i < len; i++) d[i] = Math.random() < 0.00035 ? (Math.random() * 2 - 1) * (0.3 + Math.random() * 0.7) : 0;
      return b;
    }
    function loop(buffer, type, freq, gain) {
      var s = ctx.createBufferSource(), f = ctx.createBiquadFilter(), g = ctx.createGain();
      s.buffer = buffer; s.loop = true;
      f.type = type; f.frequency.value = freq;
      g.gain.value = gain;
      s.connect(f); f.connect(g); g.connect(master);
      s.start();
    }
    function setup() {
      var AC = window.AudioContext || window.webkitAudioContext;
      if (!AC) return false;
      try { ctx = new AC(); } catch (e) { return false; }
      master = ctx.createGain(); master.gain.value = 0;
      var comp = ctx.createDynamicsCompressor();
      comp.threshold.value = -20; comp.ratio.value = 3;
      master.connect(comp); comp.connect(ctx.destination);

      verb = ctx.createConvolver(); verb.buffer = impulse(3.8, 2.6);
      var verbOut = ctx.createGain(); verbOut.gain.value = 0.5;
      verb.connect(verbOut); verbOut.connect(master);

      delay = ctx.createDelay(2); delay.delayTime.value = 0.5;
      var fb = ctx.createGain(); fb.gain.value = 0.3;
      var dl = ctx.createBiquadFilter(); dl.type = 'lowpass'; dl.frequency.value = 2000;
      var dOut = ctx.createGain(); dOut.gain.value = 0.35;
      delay.connect(dl); dl.connect(fb); fb.connect(delay); dl.connect(dOut); dOut.connect(master); dOut.connect(verb);

      padIn = ctx.createBiquadFilter(); padIn.type = 'lowpass'; padIn.frequency.value = 950; padIn.Q.value = 0.6;
      var lfo = ctx.createOscillator(), lfoG = ctx.createGain();
      lfo.frequency.value = 0.05; lfoG.gain.value = 320;
      lfo.connect(lfoG); lfoG.connect(padIn.frequency); lfo.start();
      var padOut = ctx.createGain(); padOut.gain.value = 0.9;
      padIn.connect(padOut); padOut.connect(master); padOut.connect(verb);

      loop(brown(8), 'lowpass', 420, 0.045);
      loop(crackle(5), 'highpass', 1800, 0.05);
      return true;
    }
    function pad(t, ch) {
      ch.notes.forEach(function (m) {
        [['sine', 0, 0.05], ['triangle', 5, 0.02], ['triangle', -6, 0.02]].forEach(function (o) {
          var osc = ctx.createOscillator(), g = ctx.createGain();
          osc.type = o[0]; osc.frequency.value = mtof(m); osc.detune.value = o[1];
          g.gain.setValueAtTime(0.0001, t);
          g.gain.exponentialRampToValueAtTime(o[2], t + 2.6);
          g.gain.setValueAtTime(o[2], t + BAR - 0.4);
          g.gain.exponentialRampToValueAtTime(0.0001, t + BAR + 3);
          osc.connect(g); g.connect(padIn);
          osc.start(t); osc.stop(t + BAR + 3.2);
        });
      });
      var b = ctx.createOscillator(), bg = ctx.createGain();
      b.type = 'sine'; b.frequency.value = mtof(ch.bass);
      bg.gain.setValueAtTime(0.0001, t);
      bg.gain.exponentialRampToValueAtTime(0.09, t + 1.5);
      bg.gain.setValueAtTime(0.09, t + BAR - 0.6);
      bg.gain.exponentialRampToValueAtTime(0.0001, t + BAR + 1.2);
      b.connect(bg); bg.connect(master);
      b.start(t); b.stop(t + BAR + 1.4);
    }
    function pluck(t, m, vel) {
      var f = mtof(m);
      var o = ctx.createOscillator(), o2 = ctx.createOscillator(), g = ctx.createGain(), g2 = ctx.createGain(), lp = ctx.createBiquadFilter();
      o.type = 'sine'; o.frequency.value = f;
      o2.type = 'triangle'; o2.frequency.value = f * 2;
      g.gain.setValueAtTime(0.0001, t);
      g.gain.exponentialRampToValueAtTime(0.07 * vel, t + 0.015);
      g.gain.exponentialRampToValueAtTime(0.0001, t + 2.4);
      g2.gain.setValueAtTime(0.0001, t);
      g2.gain.exponentialRampToValueAtTime(0.012 * vel, t + 0.01);
      g2.gain.exponentialRampToValueAtTime(0.0001, t + 0.8);
      lp.type = 'lowpass'; lp.frequency.value = 2600;
      o.connect(g); o2.connect(g2); g.connect(lp); g2.connect(lp);
      var out = lp;
      if (ctx.createStereoPanner) {
        var pan = ctx.createStereoPanner();
        pan.pan.value = Math.random() * 1.2 - 0.6;
        lp.connect(pan); out = pan;
      }
      out.connect(master); out.connect(delay); out.connect(verb);
      o.start(t); o2.start(t); o.stop(t + 2.6); o2.stop(t + 1);
    }
    function chordAt(t) {
      var i = Math.floor((t - startT) / BAR);
      return CH[((i % CH.length) + CH.length) % CH.length];
    }
    function tick() {
      var ahead = ctx.currentTime + 2.5;
      while (nextChordT < ahead) {
        pad(nextChordT, CH[chordIdx % CH.length]);
        chordIdx++;
        nextChordT += BAR;
      }
      while (nextPluckT < ahead) {
        if (Math.random() < 0.2) {
          var c = chordAt(nextPluckT);
          var steps = [-2, -1, -1, 0, 1, 1, 2];
          melIdx = clamp(melIdx + steps[Math.floor(Math.random() * steps.length)], 0, c.mel.length - 1);
          pluck(nextPluckT + Math.random() * 0.03, c.mel[melIdx], 0.5 + Math.random() * 0.5);
        }
        nextPluckT += 0.5;
      }
    }
    function go() {
      var now = ctx.currentTime;
      if (!started) { startT = now + 0.1; nextChordT = startT; nextPluckT = startT + 2; started = true; }
      master.gain.cancelScheduledValues(now);
      master.gain.setValueAtTime(master.gain.value, now);
      master.gain.linearRampToValueAtTime(target(), now + 2.5);
      clearInterval(timer);
      tick();
      timer = setInterval(tick, 250);
    }
    return {
      play: function () {
        if (!ctx && !setup()) return false;
        clearTimeout(stopTimer); stopTimer = null;
        playing = true;
        if (ctx.state === 'suspended') ctx.resume().then(go, go); else go();
        return true;
      },
      pause: function () {
        if (!ctx) return;
        playing = false;
        clearInterval(timer); timer = null;
        var now = ctx.currentTime;
        master.gain.cancelScheduledValues(now);
        master.gain.setValueAtTime(master.gain.value, now);
        master.gain.linearRampToValueAtTime(0, now + 1.2);
        clearTimeout(stopTimer);
        stopTimer = setTimeout(function () { if (!playing && ctx.state === 'running') ctx.suspend(); }, 1400);
      },
      volume: function (v) {
        vol = clamp(v, 0, 1);
        if (ctx && playing) master.gain.setTargetAtTime(target(), ctx.currentTime, 0.15);
      }
    };
  }

  function initMusic(root) {
    var toggles = $$('[data-dlp-music-toggle]', root);
    if (!toggles.length) return;
    var vol = $('[data-dlp-volume]', root), vinyl = $('[data-dlp-vinyl]', root), float = $('[data-dlp-float]', root);
    var hero = $('[data-dlp-hero]', root), chill = $('.dlp-chill', root);
    var engine = Chill(), on = false, ever = false, vis = { hero: true, chill: false }, hideT = null;
    var PLAY = 'M8 5v14l11-7z', PAUSE = 'M7 5h4v14H7zM13 5h4v14h-4z';

    toggles.forEach(function (t) {
      var l = $('[data-dlp-music-label]', t);
      t._off = l ? l.textContent : '';
      t._on = t.classList.contains('dlp-btn') ? 'Pause' : 'Sound off';
    });
    function updateFloat() {
      if (!float) return;
      var show = ever && !vis.hero && !vis.chill;
      clearTimeout(hideT);
      if (show) {
        float.hidden = false;
        requestAnimationFrame(function () { float.classList.add('is-visible'); });
      } else {
        float.classList.remove('is-visible');
        hideT = setTimeout(function () { if (!float.classList.contains('is-visible')) float.hidden = true; }, 400);
      }
    }
    function sync() {
      toggles.forEach(function (t) {
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
        var l = $('[data-dlp-music-label]', t);
        if (l) l.textContent = on ? t._on : t._off;
        var p = t.querySelector('svg path[d="' + PLAY + '"], svg path[d="' + PAUSE + '"]');
        if (p) p.setAttribute('d', on ? PAUSE : PLAY);
      });
      if (vinyl) vinyl.classList.toggle('is-playing', on && !RM);
      updateFloat();
    }
    toggles.forEach(function (t) {
      t.addEventListener('click', function () {
        if (on) { engine.pause(); on = false; }
        else {
          if (vol) engine.volume(vol.value / 100);
          on = engine.play();
          if (on) ever = true;
        }
        sync();
      });
    });
    if (vol) vol.addEventListener('input', function () { engine.volume(vol.value / 100); });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.target === hero) vis.hero = en.isIntersecting;
          if (en.target === chill) vis.chill = en.isIntersecting;
        });
        updateFloat();
      }, { threshold: 0.05 });
      if (hero) io.observe(hero);
      if (chill) io.observe(chill);
    }
  }

  /* ---------- Start ---------- */
  function init(root) {
    if (root._dlp) return;
    root._dlp = true;
    var data = {};
    var raw = $('[data-dlp-data]', root);
    try { data = JSON.parse(raw ? raw.textContent : '{}') || {}; } catch (e) { data = {}; }
    var money = makeMoney(data.currency);
    root.classList.add('is-js');
    [initReveal, initAnchors, initFlips, initTimeline, initBrew, initClock, initQuick, initMusic].forEach(function (fn) {
      try { fn(root, data, money); } catch (e) { if (window.console) console.error('[decaf-lp]', e); }
    });
    [initHero, initBuy, initAbo].forEach(function (fn) {
      try { fn(root, data, money); } catch (e) { if (window.console) console.error('[decaf-lp]', e); }
    });
  }
  /* Helfer für dlp-plus.js (Filter-Modus, Rituale, Spiele) */
  window.DLP = { makeMoney: makeMoney, cartAdd: cartAdd, busy: busy, done: done, fail: fail, segRender: segRender,
    grindLabel: grindLabel, sizeLabel: sizeLabel, grams: grams, esc: esc, RM: RM };

  function boot() { $$('[data-dlp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
